import { useEffect } from 'react';

const useAdsenseScript = (): void => {
	useEffect(() => {
		const scriptId = 'adsbygoogle-script';
		if (!document.getElementById(scriptId)) {
			const script = document.createElement('script');
			script.id = scriptId;
			script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
			script.async = true;
			document.head.appendChild(script);


			console.log('добавлен adsbygoogle-script');
		}
	}, []);
};

export default useAdsenseScript;
